export const REFERRAL_INPUT_TEST_ID = 'referral-input'
export const REFERRAL_SHARE_BUTTON_TEST_ID = 'referral-share-button'
export const REFERRAL_SHARE_MENU_TEST_ID = 'referral-share-menu'
export const REFERRAL_COPY_OPTION_TEST_ID = 'referral-copy-option'
export const REFERRAL_SHARE_X_OPTION_TEST_ID = 'referral-share-x-option'
export const REFERRAL_TOOLTIP_TEST_ID = 'referral-tooltip'
export const REFERRAL_STEPS_CONTAINER_TEST_ID = 'referral-steps-container'
export const REFERRAL_CONTAINER_TEST_ID = 'referral-container'
export const REFERRAL_HOW_IT_WORKS_BUTTON_TEST_ID = 'referral-how-it-works-button'
export const REFERRAL_ARROW_DOWN_ICON_TEST_ID = 'referral-arrow-down-icon'
export const REFERRAL_ARROW_UP_ICON_TEST_ID = 'referral-arrow-up-icon'
